<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Case Overview</h5>
 <div class="d-flex gap-2 align-items-center ms-auto">
    <button type="button" 
            class="btn btn-outline-secondary btn-sm" 
            (click)="viewHistory()">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
</div>

<div class="modal-body">
  <div *ngIf="items" style="max-height: 60vh; overflow-y: auto;">
    <div *ngFor="let item of items.caseOverviewItems" class="d-flex align-items-start mb-3 pb-3 border-bottom">
      <button type="button" 
              class="btn btn-link text-danger p-0 me-3" 
              (click)="removeOverviewItem(item.id)"
              title="Delete">
        <fa-icon [icon]="faTrashAlt"></fa-icon>
      </button>
      
      <div style="flex: 1; word-wrap: break-word; white-space: pre-wrap;">
        {{item.text}}
        <small class="text-muted d-block mt-1">
          ({{item.addedBy.firstName}} {{item.addedBy.lastName}} - {{item.addedDateTime | date:'dd/MM/yyyy HH:mm'}})
          <fa-icon *ngIf="item.fromCaseNotes" [icon]="faClipboard" class="ms-1"></fa-icon>
        </small>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-start">
  <button type="button" 
          class="btn btn-success rounded-circle" 
          (click)="addOverviewItem()"
          style="width: 40px; height: 40px;">
    <fa-icon [icon]="faPlus"></fa-icon>
  </button>
</div>